import { send_request } from './Request';

const BILLING_PREFIX = 'authz-service/v3/billing';

function isSuccessfulResponse(response) {
  return (
    response &&
    response.status === 200 &&
    response.data &&
    !response.isAxiosError &&
    !response.response
  );
}

export async function fetchSubscription() {
  const response = await send_request(`${BILLING_PREFIX}/subscription`, '', {}, 'GET');
  return isSuccessfulResponse(response) ? response.data : null;
}

export async function fetchCreditBalance() {
  const response = await send_request(`${BILLING_PREFIX}/credits/balance`, '', {}, 'GET');
  return isSuccessfulResponse(response) ? response.data : null;
}

export async function fetchCreditHistory(limit = 50) {
  const response = await send_request(
    `${BILLING_PREFIX}/credits/history`,
    '',
    { limit },
    'GET'
  );
  return isSuccessfulResponse(response) ? response.data || [] : [];
}

export async function fetchUsageSummary() {
  const response = await send_request(`${BILLING_PREFIX}/usage-summary`, '', {}, 'GET');
  return isSuccessfulResponse(response) ? response.data : null;
}
